<template>
    <div class="c-tooltip">
        <button class="c-tooltip__button c-button c-button--icons" ref="toggle" @click="openDialog">
            <span class="c-button__icon">?</span>
            {{ text }}
        </button>

        <dialog class="c-tooltip__dialog" popover="auto" tabindex="-1" ref="dialog">
            <button class="c-tooltip__close c-button-close" @click="closeDialog"></button>

            <div class="c-tooltip__content">
                <slot></slot>
            </div>
        </dialog>
    </div>
</template>

<script>
    export default {
        props: {
            text: { type: String },
            open: { type: Boolean }
        },
        watch: {
            open: {
                handler: function (val) {
                    if (val) {
                        this.openDialog();
                    } else {
                        this.closeDialog();
                    }
                }
            }
        },
        methods: {
            openDialog: function () {
                this.$refs.dialog.showPopover();
                this.$refs.dialog.focus();
                this.positionDialog();
                this.$emit("open");
            },
            closeDialog: function () {
                this.$refs.dialog.hidePopover();
                this.$refs.toggle.focus();
                this.$emit("close");
            },
            toggleDialog: function (evt) {
                if (evt.newState === "closed") {
                    this.closeDialog();
                } else {
                    this.openDialog();
                }
            },
            positionDialog: function () {
                const dialog = this.$refs.dialog;
                const dialogPosition = this.$refs.dialog.getBoundingClientRect();
                const togglePosition = this.$refs.toggle.getBoundingClientRect();
                dialog.style.top = `${togglePosition.bottom + window.scrollY + 15}px`;
                dialog.style.left = `${togglePosition.left + togglePosition.width - dialogPosition.width + window.scrollX}px`;
            }
        },
        mounted: function () {
            // broadcast open / close events on toggle
            this.$refs.dialog.addEventListener("toggle", this.toggleDialog);

            // adjust dialog position on scroll
            window.addEventListener("scroll", this.positionDialog, true);

            // adjust dialog position on resize
            window.addEventListener("resize", this.positionDialog);

            // open dialog if set to open
            if (this.open) {
                this.openDialog();
            }
        }
    };
</script>